import { useCallback } from 'react';

import type { HasMenuIdAndVisible } from '../../../../common/types';
import { useUserMenuData } from '../../../../controllers/user-state/user-menu-data-provider';

export const useOnSave = () => {
	const { setUserMenuData } = useUserMenuData();

	return useCallback(
		(
			updatedItemCustomizationData: HasMenuIdAndVisible[],
			updatedShortcutCustomizationData: HasMenuIdAndVisible[],
		) => setUserMenuData(updatedItemCustomizationData.concat(updatedShortcutCustomizationData)),
		[setUserMenuData],
	);
};
